function InvoiceNumberSetting() {
    return (
      <>
        <div className="font-bold text-lg mb-16">InvoiceNumberSetting</div>
      </>
    );
  }
  
  export default InvoiceNumberSetting;